import React from 'react';
import ClientPlanning from './ClientPlanning';
import ClientRouteTemplate from './ClientRouteTemplate';

const ClientPlanningRoute = (props) => (
  <ClientRouteTemplate 
    {...props}
    Component={ClientPlanning}
    componentName="Planning"
  />
);

export default ClientPlanningRoute;
